import apiHelper from '../helper/ApiHelper';
import { showErrorToast } from "../utils/AlertUtils";

const SubscriptionService = {
    async getSubscriptionPlans() {
        try {
          return await apiHelper('/subscriptions');
        } catch (error) {
          console.error('Error fetching plans:', error);
          showErrorToast(error.message);
          throw error;
        }
    },
    async getPlansHistory() {
      try {
        return await apiHelper('/subscriptions/history');
      } catch (error) {
        console.error('Error fetching plans history:', error);
        showErrorToast(error.message);
        throw error;
      }
    },
    async createOrder(orderData) {
        try {
            return await apiHelper('/subscriptions/create-order', 'POST', orderData);
        } catch (error) {
            console.error('Error creating order:', error);
            showErrorToast(error.message);
            throw error;
        }
  },
};

export default SubscriptionService;